import { useToast } from 'primevue/usetoast'

type ToastInstance = ReturnType<typeof useToast>

let toast: ToastInstance | null = null

// initToast captures the toast service; call once from App.vue setup (inside an active instance).
export const initToast = () => {
    toast = useToast()
}

export const PrintSuccess = (message: string) => {
    toast?.add({ severity: 'success', summary: message, life: 3000 })
}

export const PrintError = (message: string) => {
    toast?.add({ severity: 'error', summary: message, life: 5000 })
}
